import {FAILURE_POSTFIX, REQUEST_POSTFIX, SERVER_API_PREFIX, SUCCESS_POSTFIX} from 'new-constants/api.constants';
import {FetchProgressState} from './fetch-progress.reducer.types';

const initialState: FetchProgressState = {};

export const fetchProgressReducer = (previousState = initialState, action): FetchProgressState => {
	if (!action.type.startsWith(SERVER_API_PREFIX)) {
		return previousState;
	}

	if (action.type.endsWith(REQUEST_POSTFIX)) {
		const fetchConstant = action.type.replace(REQUEST_POSTFIX, '');

		return {
			...previousState,
			[fetchConstant]: true,
		};
	}

	if (action.type.endsWith(SUCCESS_POSTFIX) || action.type.endsWith(FAILURE_POSTFIX)) {
		const fetchConstant = action.type.replace(SUCCESS_POSTFIX, '').replace(FAILURE_POSTFIX, '');

		return {
			...previousState,
			[fetchConstant]: false,
		};
	}

	return previousState;
};
